export const hospitalFinancialsColumns = [
  'id',
  '_cdc_hash',
  '_cdc_seq',
  'r1_id',
  'revint_id',
  'account_number',
  'amount',
  'batch_id',
  'billing_indicator',
  'check_id',
  'co_insurance',
  'co_payment',
  'collection_agency',
  'deductible',
  'deposit_date',
  'drg_from_remit',
  'fk_hospital__data_doc_new_id',
  'flags__bad_debt_write_off',
  'flags__charity_care_write_off',
  'flags__patient_discount',
  'flags__patient_payment',
  'invoice_number',
  'metadata__correlation_derived_date',
  'metadata__correlation_id',
  'metadata__engagement_id',
  'metadata__engagement_name',
  'metadata__modified_by',
  'metadata__modified_date',
  'metadata__pipeline_id',
  'metadata__pipeline_name',
  'monthly_file',
  'non_covered',
  'patient_responsibility',
  'payer__code',
  'payer__financial_class',
  'payer__name',
  'payer__plan_code',
  'payer__plan_name',
  'payer__position',
  'return_transaction_unique_identifier',
  'snapshot_id',
  'system_id',
  'transaction__post_date',
  'transaction__transaction_code',
  'transaction__transaction_code_description',
  'transaction__transaction_date',
  'transaction__transaction_id',
  'transaction__transaction_type',
  'visit_transaction_reassessment_exempt_flag',
  'weekly_file',
];
